import { generateActionCreator as generate, reduxTypes as types } from 'ggtmo-utils';


export const ADMIN_GET_SUBMISSION_GROUP = generate('ADMIN_GET_SUBMISSION_GROUP', { type: types.ASYNC });
export const ADMIN_UPDATE_SUBMISSION_GROUP = generate('ADMIN_UPDATE_SUBMISSION_GROUP', { type: types.ASYNC });
export const ADMIN_SELECT_SUBMISSION_GROUP = generate('ADMIN_SELECT_SUBMISSION', { type: types.SYNC });
export const ADMIN_CREATE_SUBMISSION = generate('ADMIN_CREATE_SUBMISSION', { type: types.ASYNC });
